import axios from './productInstance'
import { SaveLaserProfileRequest } from '@/types/laserProfile'


const saveLaserProfile = async (data: SaveLaserProfileRequest) => {
	try {

		const hasId = !!data?.id;

		console.log('saveLaserProfile', hasId, data);

		const res =  hasId
			? await axios.put(`/hatchprofiles/`, data)
			: await axios.post(`/hatchprofiles/`, data)


		return res.data

	} catch (error) {
		console.error("Error saving laser profile data:", error);
		return error;
	}
};

export default saveLaserProfile;